import { EventEmitter } from 'events';
import WalletConnectCore from '@walletconnect/core';
import * as cryptoLib from '@walletconnect/iso-crypto';

import util from './util';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  isConnected,
  getConnectUrl,
  getAddress,
  getSession,
  setSession,
  connect,
  cancelConnect,
  disconnect,
  reconnect,
  ethSign,
  ethSend,
};

let g_connectUrl = '';
let g_connector;
let g_session = null;
let g_connectCallback = null;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}

function setSession(session) {
  g_session = session;
}
function getSession() {
  return g_connector && g_connector.session;
}
function isConnected() {
  return g_connector && g_connector.connected;
}
function getAddress(): string {
  let ret = '';
  if (g_connector && g_connector.accounts && g_connector.accounts.length > 0) {
    ret = g_connector.accounts[0];
  }
  return ret;
}
function getConnectUrl() {
  return g_connectUrl;
}

const MyQrModal = {
  open: (url, callback, other) => {
    console.log('MyQrModal.open:', url, callback, other);
    g_connectUrl = url;
    _emit('connect_url', url);
  },
  close: (...args) => {
    g_connectUrl = '';
  },
};

const MyStorage = {
  getSession: () => {
    console.log('get session:', g_session);
    return g_session;
  },
  setSession: (session) => {
    console.log('set session:', session);
    g_session = session;
    _emit('session_update');
  },
  removeSession: () => {
    console.log('remove session');
    g_session = null;
    _emit('session_update');
  },
};

class MyWalletConnect extends WalletConnectCore {
  constructor(props) {
    super({
      ...props,
      cryptoLib,
    });
  }
}

function connect(params, done) {
  console.log('params:', params);
  const { chainId } = params;

  function _done(err) {
    let extra;
    if (!err && chainId !== undefined && g_connector.chainId !== chainId) {
      util.debugLog('connect: wrong chain:', g_connector.chainId);
      extra = 'bad_chain';
    }
    done(err, extra);
  }

  g_connectCallback = _done;
  _killSession(g_connector);
  g_connector = new MyWalletConnect({
    connectorOpts: {
      bridge: 'https://bridge.walletconnect.org',
      qrcodeModal: MyQrModal,
    },
    sessionStorage: MyStorage,
  });
  if (g_connector.connected) {
    util.debugLog('connected already: accounts:', g_connector.accounts);
    _connectDone();
  } else {
    const opts = {};
    if (chainId !== undefined) {
      opts.chainId = chainId;
    }
    g_connector.createSession(opts).then(
      (result) => {},
      (err) => {
        util.debugLog('createSession failure:', err);
      }
    );
  }

  g_connector.on('connect', _onConnect);
  g_connector.on('session_update', _onUpdate);
  g_connector.on('disconnect', _onDisconnect);
}
function cancelConnect() {
  _connectDone('user_cancel');
  disconnect();
}
function disconnect(done?: (err: any) => void) {
  if (g_connector) {
    _killSession(g_connector, done);
    g_connector = null;
    g_session = null;
  }
}
function reconnect(session, done) {
  g_session = session;
  _killSession(g_connector);
  g_connector = new MyWalletConnect({
    connectorOpts: {
      bridge: 'https://bridge.walletconnect.org',
      qrcodeModal: MyQrModal,
    },
    sessionStorage: MyStorage,
  });
  if (g_connector.connected) {
    util.debugLog('reconnect success:', g_connector);
    _emit('connected');
    done();
  } else {
    done('reconnect_failed');
  }
}

function _killSession(connector, done?: (err: any) => void) {
  if (connector) {
    connector.killSession().then(
      (payload) => {
        done && done(null, payload);
      },
      (err) => done && done(err)
    );
  } else {
    done && done();
  }
}

function _onConnect(err, payload) {
  if (err) {
    console.log('connect: err:', err, payload);
  } else {
    _emit('connect');
  }
  _connectDone(err);
}
function _onUpdate(err, payload) {
  if (err) {
    console.log('update: err:', err, payload);
  } else {
    console.log('update: payload:', payload);
    _emit('update');
  }
}
function _onDisconnect(err, payload) {
  if (err) {
    console.log('disconnect: err:', err, payload);
  } else {
    console.log('disconnect: payload:', payload);
  }
  _connectDone(err);
  g_connector = null;
  _emit('disconnect');
}

function _connectDone(err) {
  if (g_connectCallback) {
    g_connectCallback(err);
    g_connectCallback = null;
  }
}
function ethSign(params, done) {
  const { from, message } = params;
  if (!g_connector) {
    done('not_connected');
  } else {
    g_connector.signMessage([from, message]).then((result) => {
      done(null, result);
    }, done);
  }
}
function ethSend(tx, done) {
  if (!g_connector) {
    done('not_connected');
  } else {
    console.log('tx:', tx);
    g_connector.sendTransaction(tx).then((result) => {
      done(null, result);
    }, done);
  }
}
